import type { EntityOption } from '@/components/EntitySelect';
import { createCompany, getCompany, listCompanies } from './api';

/** Server search for the company picker (EntitySelect). */
export async function searchCompanies(query: string): Promise<EntityOption[]> {
  const page = await listCompanies({ search: query || undefined });
  return page.results.map((c) => ({ value: String(c.id), label: c.name }));
}

/** Inline-create a company from a picker (EntitySelect `onCreate`). */
export async function createCompanyOption(name: string): Promise<EntityOption> {
  const company = await createCompany({
    name: name.trim(),
    website: '',
    address: '',
    country: '',
    notes: '',
    is_active: true,
  });
  return { value: String(company.id), label: company.name };
}

/** Resolve a company's name for a preselected id (edit mode). */
export async function resolveCompanyLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const company = await getCompany(Number(value));
  return company.name;
}
